import { Component, Input } from '@angular/core';

@Component({
  selector: 'mapfre-auditlib-form-info',
  templateUrl: './form-info.component.html',
  styleUrls: ['./form-info.component.scss']
})
export class FormInfo {

  @Input()
  infoLabel: string;

  constructor() { }



}
